import React from 'react';
import { formatEffectiveDate } from '../helpers';

const PrivacyPolicy = () => {

  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-12 col-lg-10 offset-lg-1">
          <h1 className="display-4 fw-800 text-dark opacity-85 mb-4">Privacy Policy</h1>
          <div className="card shadow-sm p-4 bg-white">
            <p className="text-muted mb-4">Effective Date: {formatEffectiveDate()}</p>
            
            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">1. Information We Collect</h5>
              <p className="text-dark opacity-75">Jumpfast Technologies collects personal and technical information that you voluntarily provide to us when engaging with our website, platforms, or services. This may include your name, email address, business information, and any other details submitted through contact forms or service requests.</p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">2. How We Use Your Information</h5>
              <p className="text-dark opacity-75">We use the information collected to deliver and enhance our technology services, respond to inquiries, manage client relationships, and ensure the security and functionality of our platforms. We may also use aggregated, anonymized data for analytics and performance improvements.</p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">3. Information Sharing</h5>
              <p className="text-dark opacity-75">We do not sell your personal information. We may share data with trusted third-party service providers who assist us in delivering our services, subject to strict confidentiality obligations. Information may also be disclosed if required by law or to protect our rights and users.</p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">4. Data Security</h5>
              <p className="text-dark opacity-75">We employ industry-standard security practices, including encryption and secure server protocols, to safeguard your personal data from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.</p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">5. Contact Us</h5>
              <p className="text-dark opacity-75">If you have any questions or concerns regarding this Privacy Policy or our data practices, please reach out to us at <a href="mailto:contact@jumpfast.tech" className="text-primary">contact@jumpfast.tech</a>.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
